import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { IGlobalState, IGlocalActions } from "../interfaces/globalState";
import {
  cardStateInitialState,
  errorInitialState,
  RequestStatus,
  themeFormattedInitialState,
} from "../constants";

export const useStore = create<
  IGlobalState & IGlocalActions,
  [["zustand/persist", Partial<IGlobalState>]]
>(
  persist(
    (set) => ({
      errorState: errorInitialState,
      setErrorState: (errorState) => {
        set(() => ({ errorState }));
      },

      cardState: cardStateInitialState,
      setCardState: (cardState) => {
        set(() => ({ cardState }));
      },

      cardList: [],
      setCardList: (cardList) => {
        set(() => ({ cardList }));
      },

      theme: themeFormattedInitialState,
      setTheme: (theme) => {
        set(() => ({ theme }));
      },

      userProfile: {
        data: null,
        status: RequestStatus.NOT_LOADED,
      },
      setUserProfile: (userProfile) => {
        set(() => ({ userProfile }));
      },

      amountState: {
        amount: "",
        anchor: "send" as const,
      },
      setAmountState: (amountState) => {
        set(() => ({
          amountState: {
            anchor: "send",
            ...amountState,
          },
        }));
      },

      paymentState: {
        payment: null,
      },
      setPaymentState: (paymentState) => {
        set(() => ({ paymentState }));
      },

      transactions: [],
      setTransactions: (transactions) => {
        set(() => ({ transactions }));
      },

      quoteState: null,
      setQuoteState: (quoteState) => {
        set(() => ({ quoteState }));
      },
    }),
    {
      name: "globalState",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        userProfile: state.userProfile,
      }),
    }
  )
);
